var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2134",
    "data-name": "Group 2134",
    transform: "translate(-1136 -230)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    width: 18,
    height: 18,
    transform: "translate(1136 230)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2133",
    "data-name": "Group 2133",
    transform: "translate(40 -26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M7205.6,7206.1a5.5,5.5,0,0,0-1.1-2.3",
    transform: "translate(-6094.031 -6934.3)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M7202.1,7201.9a8.7,8.7,0,0,0-3.2-.6c-3.1,0-6.2,1.7-6.7,4.8",
    transform: "translate(-6094.031 -6934.3)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M7205.1,7199.2a1.131,1.131,0,0,1,1.6,1.6h0l-5.5,5.5-2.2.6.6-2.2Z",
    transform: "translate(-6094.031 -6934.3)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M174.061,51.455a3.179,3.179,0,1,1-6.333,0,3.179,3.179,0,1,1,6.333,0Z",
    transform: "translate(933.924 210.146)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditContactIcon);
export default __webpack_public_path__ + "static/media/edit-contact-icon.af2f86075b6965dbc48f6c3e49abe77d.svg";
export { ForwardRef as ReactComponent };